<template>
    <COffcanvas v-if="shouldRender" placement="end" :visible="modelValue" scroll :backdrop="false">
        <COffcanvasHeader>
            <COffcanvasTitle v-if="title" v-html="title" />
            <CCloseButton
                class="text-reset btn-icon"
                @click="
                    () => {
                        $emit('update:modelValue', false);
                    }
                "
            />
        </COffcanvasHeader>
        <COffcanvasBody>
            <slot />
        </COffcanvasBody>
    </COffcanvas>
</template>
<script setup>
import { COffcanvas, COffcanvasHeader, COffcanvasTitle, COffcanvasBody, CCloseButton } from '@coreui/vue';
import { computed } from 'vue';

const props = defineProps({
    title: {
        type: String,
        required: false,
    },
    modelValue: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['update:modelValue']);

const shouldRender = computed(() => {
    return new URLSearchParams(window.location.search).get('debug') === '1';
});
</script>
